var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.open)?_c('div',[_c('button',{on:{"click":_vm.openPicker}},[_vm._v("Seleccionar archivo")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }